import Device from 'constants/deviceSizes';
import { appConfig } from 'config/customization';

import { containerStyle } from '../../styles';

export default {
  container: {
    ...containerStyle
  },
  form: {
    width: appConfig.signUp.personalInformationFullWidthFields ? '100%' : '55vw',
    [Device.mobile]: {
      width: '100%'
    },
    maxHeight: '40vh',
    overflow: 'auto'
  },
  account: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  submit: {
    textTransform: 'uppercase',
    marginTop: 20
  }
};
